<template>
  <LayoutDefault>
    <div class="compare" v-if="historyData.length > 0">
      <div class="compare__close">
        <CloseIcon @click="closeComparer"/>
      </div>

      <StoryChangeCompareItem
        v-if="historyData"
        :title-date="headerInfo.firstDate"
        :title-name="headerInfo.firstName"
        :restore-button="routeId !== firstColData.Id"
        @restore-version="onRestoreVersion(firstColData.Id)"
        @show-modal="changeContent('firstCol')"
      >
        <FormConstructorDemo
          :data-source="firstColData"
          content-blocks
          dropdown
        />
      </StoryChangeCompareItem>

      <StoryChangeCompareItem
        v-if="historyData"
        :title-date="headerInfo.secondDate"
        :title-name="headerInfo.secondName"
        :restore-button="routeId !== secondColData.Id"
        @restore-version="onRestoreVersion(secondColData.Id)"
        @show-modal="changeContent('secondCol')"
      >
        <FormConstructorDemo
          :data-source="secondColData"
          content-blocks
          dropdown
        />
      </StoryChangeCompareItem>

    </div>
  </LayoutDefault>
  <Transition name="bounce">
    <BaseModalWindow
      v-show="showStoryChangeModal"
      @close-modal="switchStoryChangeModal"
      title="История изменений"
    >
      <StoryChangeModal
        :data-table="historyData"
        :selected-default-id="selectedDefaultId"
        :origin-news-id="routeId"
        @close-modal="switchStoryChangeModal"
        @select-version="selectVersion"
      />
    </BaseModalWindow>
  </Transition>
</template>

<script>
import { computed, ref, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { useRoute } from 'vue-router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import StoryChangeCompareItem from '@/components/blocks/StoryChangeCompareItem.vue'
import FormConstructorDemo from '@/components/elements/FormConstructorDemo.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import StoryChangeModal from '@/components/modals/StoryChangeModal.vue'

export default {
  name: 'DevelopmentVersionView',
  components: {
    LayoutDefault,
    StoryChangeCompareItem,
    CloseIcon,
    BaseModalWindow,
    StoryChangeModal,
    FormConstructorDemo
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    // при перезагрузке загружает данные в первую и вторую колонки
    onBeforeMount(() => {
      // при рендере загружаем вторую колонку
      store.dispatch('setSecondColData', `/api/Utilities/GetDevelopmentForm/${route.params.id}`)
      // при рендере загружаем данные истории изменений
      store.dispatch('setChangeHistory', `/api/Utilities/GetChangeHistory/${route.params.id}`)
    })

    // данные в первой колонке
    const firstColData = computed(() => store.getters.getFirstColData)
    // данные во второй колонке
    const secondColData = computed(() => store.getters.getSecondColData)

    const showStoryChangeModal = ref(false) // состояние модалки с табличкой версий

    // ID формы с которой был переход на эту страницу
    const routeId = computed(() => +route.params.id)

    const formaterDate = (val) => {
      if (typeof val === 'string') {
        const date = new Date(val)
        return date.toLocaleDateString('ru')
      } else {
        return '--.--.--'
      }
    }

    // какая колонка сейчас редактируется
    const nameEditedCol = ref('firstCol')

    const selectedDefaultId = computed(() => {
      switch (nameEditedCol.value) {
        case 'firstCol':
          return firstColData.value.Id
        case 'secondCol':
          return secondColData.value.Id
        default:
          return 0
      }
    })

    const historyData = computed(() => store.getters.getChangeHistoryData)

    const headerInfo = computed(() => {
      const data = store.getters.getChangeHistoryData
      const obj = {
        firstName: '',
        firstDate: '',
        secondName: '',
        secondDate: ''
      }

      data.forEach((item) => {
        if (item.EntityObjectId === firstColData.value.Id) {
          obj.firstName = item.User
          obj.firstDate = formaterDate(item.Date)
        } else if (item.EntityObjectId === secondColData.value.Id) {
          obj.secondName = item.User
          obj.secondDate = formaterDate(item.Date)
        }
      })
      return obj
    })

    const selectVersion = (id) => {
      // после нажатия выбрать загружается версия в колонку из которой вызывалась модалка
      if (nameEditedCol.value === 'firstCol') {
        // изменять первую колонку NewsVersionView
        store.dispatch('setFirstColData', `/api/Utilities/GetDevelopmentForm/${id}`)
      }

      if (nameEditedCol.value === 'secondCol') {
        // изменять вторую колонку NewsVersionView
        store.dispatch('setSecondColData', `/api/Utilities/GetDevelopmentForm/${id}`)
      }

      switchStoryChangeModal()
    }

    const changeContent = (nameCol) => {
      // открывает модалку с историей версий и запоминает из какой колонки она была открыта
      nameEditedCol.value = nameCol

      switchStoryChangeModal()
    }

    const switchStoryChangeModal = () => {
      showStoryChangeModal.value = !showStoryChangeModal.value
    }

    const onRestoreVersion = (id) => {
      store.dispatch('setArticleActive', `/api/Utilities/SetActive/${id}`)
      store.commit('SetFormDataId', id)
      router.push(`/products/DevelopmentEditor/${id}`)
    }

    const closeComparer = () => {
      router.push(`/products/DevelopmentEditor/${routeId.value}`)
    }

    return {
      firstColData,
      secondColData,
      showStoryChangeModal,
      onRestoreVersion,
      closeComparer,
      switchStoryChangeModal,
      changeContent,
      selectVersion,
      nameEditedCol,
      formaterDate,
      headerInfo,
      selectedDefaultId,
      routeId,
      historyData
    }
  }
}
</script>

<style lang="scss" scoped>
.compare {
  display: flex;
  flex-wrap: wrap;
  flex: 50%;
  height: calc(100vh - 25px);
  overflow-y: auto;

      /* Стили для скролла */
    &::-webkit-scrollbar {
      width: 8px; /* ширина для горизонтального скролла */
      background-color: rgba(192, 192, 192, 0.5);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(27, 166, 218, 0.7);

      &:hover {
        background-color: rgb(27, 166, 218);
      }
    }

  &__close {
    position: fixed;
    top: 10px;
    right: 35px;
    z-index: 10;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

</style>
